import { memo } from 'react';
import PropTypes from 'prop-types';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

function IconLevar({ color = '#000000', ...other }) {
  return (
    <Box {...other}>
      <svg 
        version="1.0"
        width="100%"
        height="100%"
        viewBox="0 0 7083.000000 7083.000000" 
        preserveAspectRatio="xMidYMid meet"
      >
      <g transform="translate(0.000000,7083.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
        <path d="M55438 58916 c-8460 -6553 -24394 -18893 -35408 -27423 l-20025 -15508 -3 -7994 c-2 -6535 0 -7992 11 -7988 7 3 9242 7152 20522 15889 11281 8736 27212 21073 35403 27417 l14892 11533 0 7994 c0 4397 -2 7994 -4 7994 -2 0 -6927 -5361 -15388 -11914z"/>
        <path d="M29539 11648 c-3232 -2521 -7912 -6171 -10401 -8113 l-4525 -3530 10405 -3 c5722 -1 15083 -1 20803 0 l10399 3 -3583 2795 c-10295 8031 -17217 13430 -17220 13430 -2 0 -2647 -2062 -5878 -4582z"/>
      </g>
      </svg>
    </Box>
  );
}

IconLevar.propTypes = {
  color: PropTypes.string
};

export default memo(IconLevar);